export default [
  {
    selected: true,
    title: "CBRE Build",
    seoname: "cbre",
    year: "2019-2020",
    type: "online",
    description:
      "<p>At CBRE Build I worked on Plans Pro, a web-based floorplan editor for office spaces. I led improvements to frontend performance, built full-stack features for the administrative CMS, and built graph debugging tools to assist our in-house production team.</p>",
    visual: [
      { type: "image", url: "/img/portfolio/online/cbre/cbre1.png" },
      { type: "image", url: "/img/portfolio/online/cbre/cbre2.png" },
    ],
  },

  {
    selected: true,
    title: "Vidcode",
    seoname: "vidcode",
    year: "2016-2019",
    type: "online",
    description:
      "<p>At Vidcode I led the engineering team to build our creative coding education platform used daily in thousands of schools across the country. Major initiatives included rebuilding the teacher dashboard used by educators to track student progress, rebuilding our rendering engine, and integrating our coding platform with external LMSes.</p>",
    visual: [
      { type: "image", url: "/img/portfolio/online/vidcode/vidcode.gif" },
      { type: "image", url: "/img/portfolio/online/vidcode/01.jpg" },
      { type: "image", url: "/img/portfolio/online/vidcode/02.jpg" },
    ],
    links: [
      {
        text: "Learn more about Vidcode",
        href: "https://vidcode.com/",
        rel: "external",
      },
      {
        text: "Try out the coding platform",
        href: "https://vidcode.com/project/sandbox",
        rel: "external",
      },
    ],
  },

  {
    selected: true,
    title: "Cooper Hewitt Labs",
    seoname: "ch-pen",
    client: "Cooper Hewitt, Smithsonian Design Museum",
    year: "2014-2016",
    type: "offline",
    description:
      '<p>At Cooper Hewitt Labs, I developed the infrastructure and interfaces that expose the Cooper Hewitt\'s 200,000-object collection to the public. In addition to expanding and maintaing the <a href="https://collection.cooperhewitt.org" rel="external">collections website</a>, I developed infrastructure and tools in support of the museum\'s <a href="https://www.cooperhewitt.org/new-experience/" rel="external">in-gallery interactive experience</a> that allows visitors to engage the collection on touch-screen tables and remember their visits with an interactive pen.</p>',
    visual: [
      { type: "image", url: "/img/portfolio/online/ch/ch_01.jpg" },
      { type: "image", url: "/img/portfolio/online/ch/ch_02.jpg" },
    ],
    links: [
      {
        text: "Explore the Cooper Hewitt Collection",
        href: "https://collection.cooperhewitt.org/",
        rel: "external",
      },
      {
        text: "Read my blogposts at Cooper Hewitt Labs",
        href: "https://labs.cooperhewitt.org/author/sam/",
        rel: "external",
      },
    ],
  },
  {
    selected: true,
    title: "Mesocosm / MORE&MORE",
    seoname: "mesocosm",
    client: "Marina Zurkow",
    year: "2014-Present",
    type: "offline",
    description:
      '<p>For the artist <a href="https://o-matic.com/">Marina Zurkow</a>, I built an animation platform which is used to position, schedule, and synchronize hundreds of hand-drawn assets to compose a dynamic, pseudorandom ecosystem. The platform features prominently in two of the artist\'s series: <a href="https://o-matic.com/play/friend/mesocosmTS/index.html"><em>Mesocosm</em></a>, a series of speculative ecosystems, and <a href="https://o-matic.com/moremore/gallery.html"><em>MORE&amp;MORE</em></a>, a visualization of the ocean\'s role in international trade. Pieces from these series are in the collections of the Whitney Museum of American Art, the Hunter Museum of American Art, the Borusan Contemporary, and the Thoma Foundation.</p>',
    visual: [
      { type: "image", url: "/img/portfolio/offline/mesocosm/mesocosm_01.jpg" },
      { type: "image", url: "/img/portfolio/offline/mesocosm/moremore.jpg" },
    ],
    links: [
      {
        text: "Read More",
        href: "http://www.o-matic.com/play/friend/mesocosmTS/",
        rel: "external",
      },
    ],
  },
  {
    selected: true,
    title: "Adventures of Teen Bloggers",
    seoname: "adventures-of-teen-bloggers",

    year: 2014,
    type: "online",
    description:
      "<p>My thesis project at ITP, Adventures of Teen Bloggers is a creative-nonfiction graphic adventure that lets you become a real teen blogger from the heyday of LiveJournal.</p>",
    visual: [
      {
        type: "image",
        url: "/img/portfolio/online/teenbloggers/teenbloggers_02.jpg",
      },
      {
        type: "image",
        url: "/img/portfolio/online/teenbloggers/teenbloggers_01.jpg",
      },
      {
        type: "image",
        url: "/img/portfolio/online/teenbloggers/teenbloggers_03.jpg",
      },
    ],
    links: [
      {
        text: "Play the Game",
        href: "http://teenbloggers.net/",
        rel: "external",
      },
      {
        text: "View the Source Code",
        href: "https://github.com/sambrenner/teenbloggers/",
        rel: "external",
      },
      {
        text: "Read More",
        href: "/notes/the-adventures-of-teen-bloggers",
      },
    ],
  },
  /*
  {
    title: 'SMOG USA',
    seoname: 'smog-usa',

    year: 2014,
    type: 'online',
    description: "<p>An interactive visualization of dense smog covering American points of interest. Created for the inaugural issue of <a href=\"http://www.benkauffman.com/\" rel=\"external\">Ben Kauffman</a> and <a href=\"http://sarahrothberg.com/\" rel=\"external\">Sarah Rothberg</a>'s SMOG.</p>",
    visual: [

    ],
    links: [
      {
        text: 'View the Project',
        href: '/projects/smog'
      },
      {
        text: 'Read Issue 1 of SMOG',
        href: 'http://s-m-o-g.net',
        rel: 'external'
      }
    ]
  },
  */
  {
    selected: true,
    title: "The Trophy of the Future",
    seoname: "future-trophy",

    year: 2014,
    type: "offline",
    description:
      "<p>The world&rsquo;s first internet-enabled trophy. For my fantasy football league, I encased 320 LEDs in a gallon of resin, sat it atop a mahogany plinth and wired it up to an Arduino Yún. The trophy displays past champions, league standings and current NFL headlines.</p>",
    visual: [
      { type: "image", url: "/img/portfolio/offline/trophy/trophy_02.jpg" },
      { type: "vimeo", url: "https://player.vimeo.com/video/85608876" },
      { type: "image", url: "/img/portfolio/offline/trophy/trophy_01.jpg" },
    ],
    links: [
      {
        text: "Read About the Fabrication",
        href:
          "/notes/making-the-worlds-first-internet-enabled-fantasy-football-trophy-part-1-fabrication/",
      },
      {
        text: "Read About the Software",
        href:
          "/notes/making-the-worlds-first-internet-enabled-fantasy-football-trophy-part-2-programming/",
      },
      {
        text: "View the Source Code",
        href: "https://github.com/sambrenner/future-trophy/",
        rel: "external",
      },
    ],
  },

  {
    selected: true,
    title: "Bad Fighter",
    seoname: "badfighter",

    year: 2013,
    type: "online",
    description:
      '<p>A two-player browser-based fighting game that I built with <a href="https://michaelallison.lol/" rel="external">Mike Allison</a>. We were inspired by &ldquo;bad physics&rdquo; games like <a href="http://www.foddy.net/Athletics.html" rel="external">QWOP</a> and <a href="http://www.gravitysensation.com/sumotori/" rel="external">Sumitori Dreams</a> and wanted to capture those awkward character motions while maintaining a quick and easy experience for players.</p>',
    visual: [
      {
        type: "image",
        url: "/img/portfolio/online/badfighter/badfighter_01.gif",
      },
    ],
    links: [
      {
        text: "Play the Game",
        href: "http://badfighter.herokuapp.com",
        rel: "external",
      },
      {
        text: "View the Source Code",
        href: "https://github.com/sambrenner/badfighter/",
        rel: "external",
      },
    ],
  },
  {
    selected: true,
    title: "Mariah Carey's Hand",
    seoname: "mariah-careys-hand",

    year: 2013,
    type: "offline",
    description:
      "<p>A project that explores how accurately the position of Mariah Carey&rsquo;s hand during live performance reflects the pitch of the note she is singing, or a project about how easily data visualizations are rendered meaningless by arbitrary judgement calls.</p>",
    visual: [{ type: "vimeo", url: "https://player.vimeo.com/video/66652115" }],
    links: [
      {
        text: "Read More",
        href: "/notes/mariah-careys-hand/",
      },
    ],
  },
  {
    selected: true,
    title: "Plant Pinball",
    seoname: "plant-pinball",

    year: 2013,
    type: "offline",
    description:
      '<p>A pinball game that teaches players about the role of roots in the livelihood of a plant and the special qualities roots have developed that enable the plant to survive. Designed with the guidance of NYU biologist <a href="http://biology.as.nyu.edu/object/kennethbirnbaum" rel="external">Ken Birnbaum</a>, the game was installed in the lobby of NYU\'s <a href="http://cgsb.as.nyu.edu/page/home" rel="external">Center for Genomics and Systems Biology</a> and was exhibited at the 2013 <a href="http://www.worldsciencefestival.com/" rel="external">World Science Festival</a>.</p>',
    visual: [
      { type: "image", url: "/img/portfolio/offline/pinball/pinball_02.jpg" },
      { type: "image", url: "/img/portfolio/offline/pinball/pinball_03.jpg" },
      { type: "image", url: "/img/portfolio/offline/pinball/pinball_04.jpg" },
      { type: "image", url: "/img/portfolio/offline/pinball/pinball_01.jpg" },
    ],
    links: [
      {
        text: "Read More",
        href: "/notes/plant-pinball/",
      },
      {
        text: "View the Source Code",
        href: "https://github.com/sambrenner/plantpinball",
        rel: "external",
      },
    ],
  },
  {
    selected: false,
    title: "Be the Witness",
    seoname: "be-the-witness",
    client: "Innocence Project",
    year: 2013,
    type: "online",
    description:
      "<p>Be the Witness was a campaign for the Innocence Project, a non-profit that fights to exonerate the wrongly convicted using DNA testing, to raise awareness about wrongful convictions. I worked with a team of five other NYU grad students to produce an online quiz about the role that incorrect witness identifications play in wrongful convictions.</p>",
    visual: [
      {
        type: "image",
        url: "/img/portfolio/online/eyewitness/eyewitness_01.jpg",
      },
      {
        type: "image",
        url: "/img/portfolio/online/eyewitness/eyewitness_02.jpg",
      },
      {
        type: "image",
        url: "/img/portfolio/online/eyewitness/eyewitness_03.jpg",
      },
    ],
    links: [
      {
        text: "Visit the Project's Website",
        href:
          "https://web.archive.org/web/20140128115720/http://eyewitness.innocenceproject.org/",
        rel: "external",
      },
    ],
  },

  {
    title: "Instagramophone",
    seoname: "instagramophone",
    year: 2013,
    type: "online",
    description:
      '<p>Instagram takes your photos and makes them look bad, because vintage is trendy. Instagramophone imagines what would happen if phone calls worked the same way. You can visit <a href="https://soundcloud.com/instagramophone">Soundcloud</a> to hear the messages or read the documentation on my <a href="http://samjbrenner.com/notes/instagramophone/">blog</a>.</p>',
    visual: [{ type: "vimeo", url: "https://player.vimeo.com/video/65925832" }],
    links: [
      {
        text: "Hear the Messages",
        href: "https://soundcloud.com/instagramophone",
        rel: "external",
      },
      {
        text: "Read More",
        href: "/notes/instagramophone/",
      },
    ],
  },
  {
    title: "Il Telefono di Pavarotti",
    seoname: "il-telefono-di-pavarotti",
    year: 2013,
    type: "online",
    visual: [],
    description:
      "<p>Il Telefono di Pavarotti is a telephone-based chatroom where callers are given a Pavarotti avatar which transforms their screams into the famously-elongated B4 from <em>Nessun Dorma</em>.</p>",
    visual: [{ type: "image", url: "/img/uploads/2013/04/pav-600x385.jpg" }],
    links: [
      {
        text: "Read More",
        href: "/notes/il-telefono-di-pavarott/",
      },
    ],
  },
  {
    selected: true,
    title: "Cat Car",
    seoname: "cat-car",
    year: 2012,
    type: "offline",
    description:
      "<p>Cat Car is a cat exercise toy that allows humans to steer a cat by controlling the direction of a back-mounted laser pointer with a remote steering wheel.</p>",
    visual: [
      { type: "vimeo", url: "https://player.vimeo.com/video/55880815" },
      { type: "image", url: "/notes/wp-content/uploads/2012/12/PC152508.jpg" },
      { type: "image", url: "/notes/wp-content/uploads/2012/12/PC152506.jpg" },
    ],
    links: [
      {
        text: "Read More",
        href: "/notes/cat-car/",
      },
    ],
  },
  {
    title: "Be The Monster",
    seoname: "be-the-monster",
    year: 2012,
    type: "offline",
    description:
      "<p>Be The Monster lets children bring their drawings to life. After drawing a monster on a sheet of paper, the image is captured and a participant can control it with their own body using a Kinect.</p>",
    visual: [
      { type: "vimeo", url: "https://player.vimeo.com/video/50614938" },
      { type: "image", url: "/img/portfolio/offline/monster/monster_01.jpg" },
      { type: "image", url: "/img/portfolio/offline/monster/monster_02.jpg" },
      { type: "image", url: "/img/portfolio/offline/monster/monster_03.jpg" },
    ],
    links: [
      {
        text: "View documentation",
        href: "https://player.vimeo.com/video/50614938",
        rel: "external",
      },
    ],
  },
  {
    title: "TwitShit",
    seoname: "twitshit",
    year: 2009,
    type: "online",
    description:
      '<p>TwitShit is the world\'s first smart litterbox. Frustrated with the frequent and odiferous leavings of my roommate&#39;s cat, I rigged up a litterbox to tweet every time the cat used it to relieve himself. What I saw as a breakthrough in passive aggression was viewed mostly as a novelty, and my nostrils continued to suffer. Though the project is no longer active, <a rel="external" href="http://twitter.com/#!/reptarthecat">the archive of his regularity is available on Twitter</a>.</p>',
    visual: [
      { type: "image", url: "/img/portfolio/online/twitshit/twitshit_02.jpg" },
    ],
    links: [
      {
        text: "Read the Project's Documentation",
        href: "/notes/twitshit-2",
      },
      {
        text: "See the Tweets",
        href: "https://twitter.com/reptarthecat",
      },
    ],
  },
];
